import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'string'})

export class StringPipe implements PipeTransform {

	constructor() {

	}

	transform(val: any): string {
		if ( !val ) {
			return '';
		}
		return String(val);
	}
}
